export const logComponentDeprecation = (componentName: string): void => {
    // eslint-disable-next-line no-console
    console.warn(
        `WARN: @sport1/news-styleguide | <${componentName} /> is deprecated and will be removed in next major release`
    )
}
